import React, { useEffect, useState, useRef } from "react";
import Layout from "../../../components/mobile/Layout/layoutmobile";
import LayoutEmpte from "../../../components/mobile/Layout/layoutmobileempty";
import { getProductDetail,getMetaCategories, getMetaBrand, getMetaProduct, getCategories,getBrands,getBreadcrumb} from "../../../service/myProductService";
import { getListGiftDetail } from '../../../service/campaignService';
import { actionCart } from '../../../service/cartService';
import { ResponsiveSliderTop } from "../../../utils/constant";
import HeaderMobile from "../../../components/mobile/header/headerv2";
import ReactHtmlParser from 'react-html-parser';
import { FromatNumberVIE, RoundFloor } from '../../../utils/format';
import BundleProduct from "../../../components/mobile/BundleProduct";
import ProductSame from "../../../components/mobile/ProductSame";
import { getStoreBySKU } from "../../../service/storeService";
import { useLocation } from '@reach/router';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { checkWWishlist, deleteWishlist, createWishlist, addProductToWishlist } from '../../../service/wishlistService';
// import Head from "../../../components/Head";
import { toast } from "react-toastify";
import { isAuth } from "../../../helpers/general";
import {FunctionId} from '../../../utils/constant';
import BrandPage from '../../../components/mobile/Brand';
import {getMenuByUrl} from "../../../service/myProductService";
import ProductListPage from '../../../components/mobile/ProductListCatalog';
import {pushtracking} from '../../../service/trackingService';
import platform from 'platform';
import './css/chi-tiet-san-pham.css';

const Product = ()=> {
    const location = useLocation();
    const [operatingSystem, setOperatingSystem] = useState('Windows');
    const getOS = ()=> {
        var uA = navigator.userAgent || navigator.vendor || window.opera;
        if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) 
        { setOperatingSystem('iOS');}
      
        var i, os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
        for (i = 0; i < os.length; i++) if (new RegExp(os[i],'i').test(uA)) {
            setOperatingSystem(os[i]);
        }     
    }
    var data_color = [];
    const [temp_color_only_pc, settemp_color_only_pc] = useState([]);
    const _temp_color_only = [];
    const temp_color = [];
    const [selectedColor, setSelectedColor] = useState(0);
    const skuRef = useRef(null);
    const nameRef = useRef(null);
    const imgRef = useRef(null);
    const quanityRef = useRef(null);
    const sizeRef = useRef(null);
    const [promoCode, setPromoPode] = useState('');
    const [combCode, setComboCode] = useState('');
    const [uuDai, setUuDai] = useState('');
    const [skuProduct, setskuProduct] = useState('');
    const [idSize, setIdSize] = useState(0);
    const [idSizeCheck, setIdSizeCheck] = useState(false);
    var [dataDetail, setdataDetail] = useState([]);
    const [data, setData] = useState([]);
    const [size, setSize] = useState([]);
    const[title, setTitle] = useState('Thông tin sản phẩm');
    var _color = [];
    const loadProduct = async (uri) => {
        try {
            setTitle('Thông tin sản phẩm');
            await getProductDetail(uri).then((response) => {
                if (+response.status === 426){
                    // window.location.href = '/404.html';
                    window.location.href = location.origin;
                }
                if (response.status !== 426 || response.status !== 500 || response.status !== 404) {
                    if (response.message !== "Không tìm thấy thông tin sản phẩm!") {
                        setdataDetail(response.message);
                        setskuProduct(response.message?.sku);
                        getDataStoreBySKU(response.message?.sku);
                        if (response.message?.typectkm && response.message?.typectkm !== '') {
                            loadPromotionMsg(response.message?.sku, response.message?.typectkm);
                        }
                        // var _slug = uri?.replaceAll('/','').replaceAll('.html','');
                        // getDataProductMeta(uri?.replaceAll('/','').replaceAll('.html',''));
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'view_item',
                                'ecommerce': {
                                  'currency': "VND",
                                  'value': +response.message?.price?.import,
                                    'items': [
                                      {
                                        item_id: response.message?.sku,
                                        item_name: response.message?.name,
                                        price: +response.message?.price?.import
                                      }
                                    ]
                                }
                            });
                            try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Chi tiết sản phẩm", 0,0,'index','inWeb',[response.message?.sku],'Website Mobile').then((response)=>{
                                    // console.log('send tracking');
                                });
                            }catch(e){console.log(e)}

                        window.localStorage.setItem('name_product', response.message?.name);
                        response.message?.children?.forEach((_item, i) => {
                                if(_color.includes(_item.variant?.mau_sac) !== true){
                                    _color.push(_item.variant?.mau_sac)
                                }
                                temp_color.push({
                                    color: _item.variant?.mau_sac,
                                    sku: _item.variant?.sku
                                })
                                _temp_color_only.push({
                                    id: i,
                                    colorName: _item.variant?.mau_sac,
                                    sku: _item.variant?.sku,
                                    online: _item.online
                                });
                                
                            // }
                        }
                        );
                        setskuProduct(_temp_color_only[0]?.sku ?? response.message?.sku);
                        _color.forEach((_temp_color,i)=>{
                        
                        var data_size = [];
                        temp_color?.forEach((color) => {
                            if(_temp_color === color.color){
                                response.message?.children?.forEach((item_chil) => {
                                    if (item_chil.variant?.kich_c !== null && item_chil.variant?.sku === color.sku) {
                                        data_size.push({
                                            colorSize: item_chil.variant?.kich_c,
                                            sku: item_chil.variant?.sku,
                                            online: item_chil.online
                                        })
                                    }
                                }
                                );
                            }
                        });
                        if (data_size.length > 0) {
                            data_color.push({
                                color: { id: i, colorName: _temp_color },
                                size: data_size
                            })
                            setIdSizeCheck(true);
                        }else{
                            setskuProduct(_temp_color_only[0]?.sku ?? response.message?.sku);
                        }
                    });
                    getOS();
                    var pageViewMobile = sessionStorage.getItem("pageViewDetailMobile");
                    if (pageViewMobile == null) {
                        setTimeout(() => {
                            try{
                                // if(platform.product !== 'iPhone'){
                                // let _link = 'bibomart://product/detail?sku='+response.message?.sku;
                                // window.location.replace(_link);
                                // }

                                let _link = 'bibomart://product/detail?sku='+response.message?.sku;
                                window.location.replace(_link);

                                

                            }catch(e){}
                        }, 1000); 
                        pageViewMobile = 1;
                    } 
                    sessionStorage.setItem("pageViewDetailMobile", pageViewMobile);
                       
                    }else{
                        var _slug = uri?.replaceAll('/','').replaceAll('.html','');
                        if(categoryCate.length>0 && !categoryCate.includes(_slug) && Brand.length > 0 && !Brand.includes(_slug)){
                            // window.location.href = '/404.html';
                            window.location.href = location.origin;
                        }
                    }
                    setData(data_color);
                    setSize(data_color[0]?.size);
                    if (data_color.length === 0) {
                        settemp_color_only_pc(_temp_color_only);
                    } else {
                        settemp_color_only_pc([]);
                    }

                    var _pageViewDetailMSGMobile = sessionStorage.getItem("pageViewDetailMSGMobile");
                    if (_pageViewDetailMSGMobile !== undefined && +_pageViewDetailMSGMobile !== 1) {
                        if(response.message?.function !== undefined && FunctionId.includes(response.message?.function)===true){
                            if(response.message?.attribute?.age_group_from !== undefined && +response.message?.attribute?.age_group_from < 24){
                                setTimeout(function() {
                                    setConfigMsg(true);
                                }, 9000);
                                // setConfigMsg(true);
                                sessionStorage.setItem("pageViewDetailMSGMobile", 1);
                            }
                        } 
                    } 
                    
                }else{
                    // window.location.href = '/404.html';
                }
            });
        } catch (e) { console.log(e); }
        // LoadCategory();
    }
    const [showMore, setShowMore] = useState(true);
    const [showDes, setShowDes] = useState(false);

    const [msgGift, setMsgGift] = useState([]);
    const loadPromotionMsg = (sku, type) => {
        if (sku !== undefined && type !== '') {
            getListGiftDetail(sku, type).then((response) => {
                if (response?.status === 200 && response.message !== "Không tìm thấy dữ liệu.") {
                    setMsgGift(response?.message?.messageBrand);
                }
            });

        }
    }
    const [store, setStore] = useState(0);
    const getDataStoreBySKU = (sku) => {
        try {
            if (sku !== undefined) {
                getStoreBySKU(sku).then((response) => {
                    if (+response.status === 200 && response.message !== "Không tìm thấy dữ liệu.") {
                        setStore(response.message.length ?? 0)
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    const [productMeta, setProductMeta] = useState([]);
    const getDataProductMeta = (slug) => {
        try {
            if (slug !== undefined) {
                getMetaProduct(slug).then((response) => {
                    if (+response.status === 200) {
                        setProductMeta(response.message);
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    const [bixu, setBixu] = useState(0);
    const [uri, setUri] = useState();
    const [slug, setSlug] = useState('');

    

    const loadBrand =(slug)=>{
        try{
            getMetaBrand(slug).then((response)=>{
                if(+response.status === 200){
                    setProductMeta(response.message);
                    setTitle(response.message?.name);
                }
            });
        }catch(e){console.log(e)}
    }

    const loadCatelogry =(slug)=>{
        try{
            getMetaCategories(slug).then((response)=>{
                if(+response.status === 200){
                    setProductMeta(response.message);
                    setTitle(response.message?.name);
                }
            });
        }catch(e){console.log(e);}
    }
    const [configMsg, setConfigMsg] = useState(false);

    const [categoryCate, setCategoryCate] = useState([]);
    const [Brand, setBrand] = useState([]);
    
    const getDataCategories= async()=>{
        await getCategories().then((response)=>{
            if(+response.status === 200){
                var _uri_cate = [];
                response.message?.forEach(element => {
                    _uri_cate.push(element.url_key);
                    if(element.child?.length > 0){
                        element.child?.forEach(element1 => {
                            _uri_cate.push(element1.url_key);
                            if(element1.child.length > 0){
                                element1.child?.forEach(element2 => {
                                    _uri_cate.push(element2.url_key);
                                });
                            }
                        });
                    }
                });
                setCategoryCate(_uri_cate);
            }
        });
      }

      const loadDataBrand=async()=>{
        await getBrands().then((response)=>{
            if(+response.status === 200){
                var _uri_brand = [];
                response.message?.forEach(element => {
                    _uri_brand.push(element.url_key);
                });
                setBrand(_uri_brand);
            }
        });
      }
    useEffect(()=>{
        LoadCategory();
        window.scrollTo(0, 0);
        setShowMore(!showMore);
        setShowDes(!showDes);
        async function fetchData() {
            var _slug = uri?.replaceAll('/','').replaceAll('.html','');
            setSlug(_slug);
            await getDataCategories();
            await loadDataBrand();
            getDataProductMeta(uri?.replaceAll('/','').replaceAll('.html',''));
        }
        fetchData();
    },[])

    useEffect(() => {
        let _uri = location.pathname;
        setUri(_uri);
        if (_uri === '/undefined/') {
            window.history.back();
        }
        setCategoryCate(categoryCate);
        setBrand(Brand);
        setShowMenuBr(false);
        async function fetchData() {
            var _slug = uri?.replaceAll('/','').replaceAll('.html','');
            setSlug(_slug);
            if(categoryCate.length>0 && !categoryCate.includes(_slug) && !Brand.includes(_slug)){
                if(_slug !==undefined && !categoryCate.includes(_slug) && !Brand.includes(_slug)){
                    if(window.localStorage.getItem('bixu') && window.localStorage.getItem('bixu') !== null && window.localStorage.getItem('bixu') !== undefined){
                        setBixu(FromatNumberVIE(window.localStorage.getItem('bixu')));
                    }
                    await loadProduct(_uri);
                }
            }

        if(Brand.includes(_slug)){
            loadBrand(_slug)
            var pageView = sessionStorage.getItem("pageViewBrand");
            if (pageView == null) {
                setTimeout(() => {
                    try{
                        // if(platform.product !== 'iPhone'){
                        //     let _link = "bibomart://";
                        //     window.location.replace(_link);
                        // }
                         let _link = "bibomart://shop-mall?brandUrl="+_slug;
                        window.location.replace(_link);
                    }catch(e){}
                }, 1000); 
                pageView = 1;
            } 
            sessionStorage.setItem("pageViewBrand", pageView);
        }
        if(categoryCate.includes(_slug)){
            loadCatelogry(_slug)
            var pageView = sessionStorage.getItem("pageViewCategory");
            if (pageView == null) {
                setTimeout(() => {
                    try{
                        // if(platform.product !== 'iPhone'){
                        //     let _link = "bibomart://";
                        //     window.location.replace(_link);
                        // }
                         let _link = "bibomart://product/list?result_type=products&type=products&slug="+_slug;
                        window.location.replace(_link);
                    }catch(e){}
                }, 1000); 
                pageView = 1;
            } 
            sessionStorage.setItem("pageViewCategory", pageView);
        }
        }
        fetchData();
         // Hàm kiểm tra vị trí cuộn và cập nhật trạng thái của isVisible
         const handleScroll = () => {
            const scrollPosition = window.scrollY;
            setIsVisible(scrollPosition > 100); // Hiển thị nút khi cuộn xuống 100px
        };
        // Lắng nghe sự kiện cuộn
        window.addEventListener('scroll', handleScroll);
        // Xóa sự kiện lắng nghe khi component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, [categoryCate.length])//categoryCate.length,Brand.length

    const [breandcrumb, setBreandcrumb] = useState([]);
    const LoadCategory=()=>{
        try {
          getMenuByUrl(location.pathname?.replace('/', '')).then((response)=>{
            if(response.status === 200){
              setBreandcrumb(response.message);
            }
          })
        } catch (error) {
          console.log(error);
        }
    }
    const [isVisible, setIsVisible] = useState(false);
    const [isContactCheck, setIsContactCheck] = useState(false);
    const [modalCallIsOpen, setModalCallIsOpen] = useState(false);
    const [modalChatIsOpen, setModalChatIsOpen] = useState(false);
    const handleRedirect = (uri) => {
        window.location.href = uri;
    }
    const [isShowChooseSize, setIsShowChooseSize] = useState(false)
    const handleClickChooseSize = () => {
        setIsShowChooseSize(!isShowChooseSize);
    }
    const [quantity, setQuantity] = useState(1);
    const handlePlusClick = () => {
        setQuantity(quantity + 1);

    };
    const handleMinusClick = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1);
        }
    };

    const toggleShowMore = () => {
        setShowMore(!showMore);
        if (showMore) {
            window.scrollTo(0, 700)
        }
    }
    const handleShowDes = () => {
        setShowDes(!showDes);
    }
    const handleRedirrect = (uri) => {
       window.location.replace(uri);
    }
    const [selectedSize, setSelectedSize] = useState();
    const handleSizeClick = (e) => {
        const id = e?.target.id;
        setIdSize(id);
        const skuValue = e?.target.getAttribute("sku");
        skuRef.current.value = skuValue;
        setskuProduct(skuValue);
        getDataStoreBySKU(skuValue);
        setSelectedSize(skuValue);
    };

    let handleBy = async (e) => {
        e.preventDefault();
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            window.localStorage.setItem('urlBack', location.pathname);
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            
            if(dataDetail.typectkm && dataDetail.typectkm !== ""){
                window.localStorage.setItem('git_sku_qty', quanityRef.current.value);
                window.location.href = '/mobile/chi-tiet-mua-hang-tang-qua/'+dataDetail.linksp;
                return;
            }

            if(idSizeCheck === true){
                if(idSize === 0){
                    toast.warn('Vui lòng chọn thông tin kích cỡ.');
                    return;
                }
            }
            let params = {
                items: [{
                    product: skuRef.current.value,
                    type: 'item',
                    action: 'add',
                    quantity: +quanityRef.current.value,
                    promo_code: promoCode,
                    combo_code: combCode,
                    uudai: uuDai,
                    user_referral: window.localStorage.getItem('userReferral'),
                    id_share: window.localStorage.getItem('idShare')
                }]
            }
            pushtoCart(params);
        }
    };
    let handleByNow = async (e) => {
        e.preventDefault();
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            window.localStorage.setItem('urlBack', location.pathname);
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if(dataDetail.typectkm && dataDetail.typectkm !== ""){
                window.localStorage.setItem('git_sku_qty', quanityRef.current.value);
                window.location.href = '/mobile/chi-tiet-mua-hang-tang-qua/'+dataDetail.linksp;
                return;
            }
            if(idSizeCheck === true){
                if(idSize === 0){
                    toast.warn('Vui lòng chọn thông tin kích cỡ.');
                    return;
                }
            }
            let params = {
                items: [{
                    product: skuRef.current.value,
                    type: 'item',
                    action: 'add',
                    quantity: +quanityRef.current.value,
                    promo_code: promoCode,
                    combo_code: combCode,
                    uudai: uuDai,
                    user_referral: window.localStorage.getItem('userReferral'),
                    id_share: window.localStorage.getItem('idShare')
                }]
            }
            pushtoCart(params, true);
           
        }
    }
    const pushtoCart = (paramItem, redirect = false) => {
        try {
            actionCart(paramItem, window.localStorage.getItem('key')).then((response) => {
                if(+response.status === 200 && response.message.length > 0){
                    window.localStorage.setItem('reloadCart', true);
                    localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    if(response['message'].includes('Yêu cầu không') === true){
                        toast.warning(response['message']);
                        return;
                    }else{
                        toast.success('Thêm vào giỏ hàng thành công.');
                        if(redirect){setTimeout(() => {  window.location.href = '/cart.html'; }, 2500);}
                    }
                }
            })
            window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                        'event': 'add_to_cart',
                        'ecommerce': {
                        'currency': "VND",
                        'value': +dataDetail?.price.raw,
                            'items': [
                            {
                                item_id: skuRef.current.value,
                                item_name: dataDetail.name,
                                price: +dataDetail.price?.raw
                            }
                            ]
                        }
                    });

                    try{
                        pushtracking(window.localStorage.getItem('sessionId')??null,
                        window.localStorage.getItem('_id')??null,
                        window.localStorage.getItem('phone')??null ,
                        location.pathname, "Chi tiết sản phẩm", 0,0,'index','inWeb',[skuRef.current.value],'Website PC').then((response)=>{
                            // console.log('send tracking');
                        });
                    }catch(e){console.log(e)}
        } catch (err) {
            console.log(err);
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    const handleColorClick = (e) => {
        const id = e?.target.id;
        setSelectedColor(+id);
        setSize(data[id]?.size);
        setskuProduct('');
        setSelectedSize('');
        setStore(0)
    };
    const handleColorOnlyClick = (e) => {
        console.log(e?.target);
        const id = e?.target.id;
        setSelectedColor(+id);
        const skuValue = e?.target.getAttribute("sku");
        skuRef.current.value = skuValue;
        setskuProduct(skuValue);
        getDataStoreBySKU(skuValue);
        setSelectedSize(skuValue);
    };
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Cuộn mềm mại
        });
    };
    const handleCall = () => {
        window.location.href = `tel:${18006886}`;
    }
    const handleChatMess = () => {
        window.open('https://m.me/BiBoMart.com.vn', '_blank');
    }
    const handleChatZalo = () => {
        window.open('https://zalo.me/360706546542426311?src=qr', '_blank');
    }
    const handleLogout = () => {
        localStorage.clear();
        window.location.replace('/dang-nhap.html');
    }
    const [showMenuBr, setShowMenuBr] = useState(false);

    // if(categoryCate.length > 1 && Brand.length > 1){
    return (
        <>
            
            {
                !categoryCate.includes(slug) && !Brand.includes(slug) ? (
                    <LayoutEmpte>
                        <HeaderMobile Type={'HeaderDetailProduct'} showBanner={false} linkBanner="" showText={true} showSearchIcon={true} showNoti={true} showCart={true} showTitle={title} />
                        <div className="bg-page product-detail-page position-relative">
                        <div className="breadcurmb-mobile">
                                <ul className="m-0 ps-3 pe-3  d-flex align-items-center">
                                    <li>
                                        <a href="/"><img className="icon-home" src="/static/image/icon-home-br.png" alt="hone" /></a><i className="fa-solid fa-chevron-right"></i>
                                    </li>
                                    {
                                        breandcrumb.length > 2 ? (
                                            <>
                                             <li onClick={()=>setShowMenuBr(!showMenuBr)} className="menu-before">
                                                <div >......<i className="fa-solid fa-chevron-right"></i></div>
                                                
                                            </li>
                                            {
                                                showMenuBr ? (<li className="position-absolute menu-absolute">
                                                    <div><a href={"/"+breandcrumb[0]?.url_key+".html"}>{breandcrumb[0]?.name}</a></div>
                                                </li>):(null) 
                                            }
                                            <li>
                                                <a href={"/"+breandcrumb[1]?.url_key+".html"}>{breandcrumb[1]?.name}</a><i className="fa-solid fa-chevron-right"></i>
                                            </li>
                                            <li>
                                                <a href={"/"+breandcrumb[2]?.url_key+".html"}>{breandcrumb[2]?.name}</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </li>
                                            </>
                                        ):(null)
                                    }
                                    {
                                        breandcrumb.length === 2 ? (
                                            <>
                                            <li>
                                                <a href={"/"+breandcrumb[0]?.url_key+".html"}>{breandcrumb[0]?.name}</a><i className="fa-solid fa-chevron-right"></i>
                                            </li>
                                            <li>
                                                <a href={"/"+breandcrumb[1]?.url_key+".html"}>{breandcrumb[1]?.name}</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </li>
                                            </>
                                        ):(null)
                                    }
                                    {
                                        breandcrumb.length === 1 ? (
                                            <li>
                                                <a href={"/"+breandcrumb[0]?.url_key+".html"}>{breandcrumb[0]?.name}</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </li>
                                        ):(null)
                                    }
                                                                       
                                    {/* <li>
                                        <a href={"/"+dataDetail.linksp}>{dataDetail.name}</a>
                                    </li> */}
                                </ul>
                            </div>
                        <div className="row bg-detail">
                        {/* <h1 className="d-none">{dataDetail?.name}</h1> */}
                            <input ref={skuRef} hidden name="sku" defaultValue={skuProduct ?? dataDetail?.sku} />
                            <input ref={nameRef} hidden name="name" defaultValue={dataDetail?.name} />
                            <input ref={imgRef} hidden name="img" defaultValue={dataDetail?.thumbnail_mini} />
                            <h2 className="d-none">{dataDetail?.name}</h2>
                            <div className="col-12 product-detail-img   position-relative">
                                {
                                    dataDetail.attribute?.images.length > 0 ? (
                                        <Carousel key=""
                                            responsive={ResponsiveSliderTop}
                                            showDots={true}
                                            autoPlay={true}
                                            autoPlaySpeed={4000}
                                            infinite={true}
                                        >
                                            {
                                                dataDetail.attribute?.images.map((item, i) => {
                                                    return <div key={i} className="slider-product">
                                                        <img src={item.original.replace('origin','normal')} alt={dataDetail.name} title={dataDetail.name} />
                                                    </div>
                                                })
                                            }

                                        </Carousel>
                                    ) : (null)
                                }

{
                                dataDetail.labelPromo ? (
                                    <img src={dataDetail.labelPromo['imageWeb']['mobileDetail']['url']} alt="icon-chinh-hang" className="position-absolute"
                                    style={dataDetail.labelPromo['position']['bottom']?({
                                        width:+dataDetail.labelPromo['imageWeb']['mobileDetail']['sizeImage']['width'],
                                        height:+dataDetail.labelPromo['imageWeb']['mobileDetail']['sizeImage']['height'],
                                        left:+ dataDetail.labelPromo['position']['left'],
                                        bottom:+ dataDetail.labelPromo['position']['bottom'],
                                        zIndex:1
                                }):({
                                    width:+dataDetail.labelPromo['imageWeb']['mobileDetail']['sizeImage']['width'],
                                    height:+dataDetail.labelPromo['imageWeb']['mobileDetail']['sizeImage']['height'],
                                    left:+ dataDetail.labelPromo['position']['left'],
                                    top:+ dataDetail.labelPromo['position']['top'],
                                    zIndex:1
                            })
                                        
                                    }/>
                                ):(null)
                            }
                            </div>

                            {
                                dataDetail.namePromotion  && dataDetail?.namePromotion !== 'Mua là có quà' ? (
                                    <div className="col-12 product-detail-title in-f">
                                        <span>{dataDetail.namePromotion}</span>
                                    </div>
                                ) : (null)
                            }
                        </div>

                        {
                            //bo msg product gift
                            msgGift.length > 0 ? (
                                <div className="row mgt-10 pdx-30 bg-detail">
                                    <div className="text-gift-detail">
                                        {
                                            msgGift.map((item, i) => {
                                                return <ul><li><div key={i}>{item}</div></li></ul>
                                            })
                                        }
                                    </div>
                                </div>
                            ) : (null)
                        }
                        <div className="row mgt-10 pdx-24 bg-detail">
                            <div className="col-12 text-detail-title">
                                <span>{dataDetail.name}</span>
                            </div>
                            <div className="row price-detail pdt-10">
                                <div className="col-6">
                                    {
                                        +dataDetail?.price?.raw > +dataDetail?.price?.discount ? (
                                            <>
                                                <span className="price-sale">
                                                    {
                                                        FromatNumberVIE(dataDetail?.price?.raw)
                                                    }
                                                    đ</span><br /></>
                                        ) : (null)
                                    }

                                    <div className="item-sale">
                                        <span className="detail-price-item">
                                            {FromatNumberVIE(dataDetail?.price?.discount)} đ</span>
                                        {
                                            +dataDetail?.price?.raw > +dataDetail?.price?.discount ? (
                                                <div className="box-price-percent in-f">
                                                    <span className="price-percent">-
                                                        {
                                                            RoundFloor(100 - (+dataDetail?.price?.discount / +dataDetail?.price?.raw * 100))
                                                        }
                                                        %</span>
                                                </div>
                                            ) : (null)
                                        }

                                    </div>
                                </div>
                                <div className="col-6 nav-available">
                                    {
                                        dataDetail.hotdeal ? (
                                            <>
                                                <div className="available-item">
                                                    <span className="color_width" data-title="0" data-toggle="tooltip" style={{ "width": (+dataDetail.hotdeal?.quantity / +dataDetail.hotdeal?.total) * 100 }} data-original-title="" title=""></span>
                                                </div>
                                                <img className="image-animation" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/Vector.png" alt="icon" style={{ "left": (+dataDetail.hotdeal?.quantity / +dataDetail.hotdeal?.total) * 100 - 5 }} />
                                                <span className="available-text">Còn {+dataDetail.hotdeal?.quantity} sản phẩm</span>
                                            </>
                                        ) : (null)
                                    }

                                </div>
                            </div>
                        </div>
                        {/* Cộng -trừ */}
                        <div className="row number-detail mgt-10 bg-detail">
                            <div className="col-6 text-detail in-f">
                                <span>Chọn số lượng</span>
                            </div>
                            <div className="col-6 boder-detail in-f">
                                <div className="detail-number in-f">
                                    <div className="number-minus in-f" onClick={handleMinusClick}><i className="fa fa-minus"></i></div>
                                    <div><input ref={quanityRef} className="number-now in-f" name="quantity" value={quantity} /></div>
                                    <div className="number-plus in-f" onClick={handlePlusClick}> <i className="fa fa-plus"></i></div>
                                </div>
                            </div>
                        </div>

                        {
                            temp_color_only_pc.length > 0 ? (

                                <div className="row color-detail mgt-10 bg-detail pdx-24">
                                    <div className="col-12 text-detail">
                                        <span>Chọn màu sắc</span>
                                    </div>
                                    <div className="col-12 detail-type mgt-10">
                                        <ul>
                                            {
                                                temp_color_only_pc?.map((item, i) => (
                                                    item?.colorName !== '' ? (
                                                        item.online === true ? (<li key={item.id} data={item.id} className={item.id == selectedColor ? 'select-attribute' : ''}
                                                            onClick={(e) => handleColorOnlyClick(e)}>
                                                            <div className="box-color-boder" >
                                                                <div className="color-item 123" style={{ backgroundColor: item?.colorName }} id={i} sku={item.sku} >
                                                                    {
                                                                        item?.colorName?.includes('#') === false ? (item?.colorName) : (null)
                                                                    }
                                                                </div>
                                                            </div>
                                                        </li>) : (<li key={item.id} data={item.id} className="disabled_variant">
                                                            <div className="box-color-boder" >
                                                                <div className="color-item 123" style={{ backgroundColor: item?.colorName }} id={i} sku={item.sku} >
                                                                    {
                                                                        item?.colorName?.includes('#') === false ? (item?.colorName) : (null)
                                                                    }
                                                                </div>
                                                            </div>
                                                        </li>)

                                                    ) : (null)
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            ) : (null)
                        }
                        {
                            data.length > 0 ? (
                                <>
                                    
                                        {
                                            data[0]?.color?.colorName !== '' && data[0]?.color?.colorName !== null ? (
                                                <div className="row color-detail mgt-10 bg-detail pdx-24">
                                                    <div className="col-12 text-detail">
                                                        <span>Chọn màu sắc</span>
                                                    </div>
                                                    <div className="col-12 detail-type mgt-10">
                                                        <ul>
                                                            {
                                                                data?.map((item, i) => (
                                                                    item?.color?.colorName !== '' ? (
                                                                        <li key={item.color.id} data={item.color.id} className={item.color.id == selectedColor ? 'select-attribute' : ''}
                                                                            onClick={(e) => handleColorClick(e)}>
                                                                            <div className="box-color-boder" id={i}>
                                                                                <div className="color-item 456" style={{ backgroundColor: item?.color?.colorName }} id={i} sku={item.sku} >
                                                                                    {
                                                                                        item?.color?.colorName?.includes('#') === false ? (item?.color?.colorName) : (null)
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    ) : (null)
                                                                ))
                                                            }
                                                        </ul>
                                                    </div>
                                                    </div>
                                            ) : (null)
                                        }
                                   
                                    {
                                        size && size?.length > 0 && size[0]?.colorSize !== null ? (
                                            <div className="row size-detail mgt-10 bg-detail pdx-24">
                                                <div className="col-12 text-detail">
                                                    <span>Chọn kích cỡ</span>
                                                </div>
                                                <div className="col-12 detail-type mgt-10 size-product">
                                                    <ul>
                                                        {
                                                            size?.map((item) => (
                                                                item.colorSize !== null ? (
                                                                    item.online === true ? (<li key={item.sku} className={selectedSize === item.sku ? "select-attribute" : ''}
                                                                        sku={item.sku} onClick={(e) => handleSizeClick(e)}
                                                                        id={item.colorSize} >
                                                                        <div className="box-size in-f">
                                                                            <span id={item.colorSize} sku={item.sku}>{item.colorSize}</span>
                                                                        </div>
                                                                    </li>) : (<div key={item.sku} className="disabled_variant">
                                                                        <div className="box-size in-f">
                                                                            <span>{item.colorSize}</span>
                                                                        </div>
                                                                    </div>)

                                                                ) : (null)
                                                            ))
                                                        }
                                                    </ul>
                                                    <input ref={sizeRef} hidden name="size" defaultValue={selectedSize} />
                                                </div>
                                            </div>
                                        ) : (null)
                                    }

                                </>
                            ) : (null)
                        }

                        <div className="row mgt-10 bg-detail">
                            <div className="col-12" onClick={() => handleRedirect('/mobile/cua-hang-gan-ban.html?' + uri)}>
                                <button className="button-store">CỬA HÀNG GẦN BẠN</button>
                            </div>
                            <div className="col-12 tex-store in-f mgt-10">
                                {
                                    store > 0 ? (
                                        <span> {store} cửa hàng hiện đang có sản phẩm này</span>
                                    ) : (
                                        <span> Chưa có thông tin cửa hàng.</span>
                                    )
                                }
                            </div>
                        </div>

                        <div className="row mgt-10 bg-detail">
                            <div className="row mgx-0" onClick={handleShowDes}>
                                <div className="col-10 infor-product-title">
                                    <span>Mô tả sản phẩm</span>
                                </div>
                                <div className="col-2 header-right">
                                    <img src={showDes ? ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/up.png") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/down.png")} alt="icon"/>
                                </div>
                            </div>
                            {
                                showDes ? (
                                    <div className="col-12 pdx-24 infor-product-text mgt-10">
                                        <div className="col-12 box-brand">
                                              <span>SKU : {dataDetail.sku}</span> 
                                            </div>
                                        {dataDetail.attribute?.brand_name ? (
                                            <div className="col-12 box-brand">
                                              <span>Thương hiệu :</span> <a className="brand" href={dataDetail.attribute?.url_brand+".html"}>{dataDetail.attribute?.brand_name}</a> 
                                            </div>
                                            
                                            ) : (null)}
                                        <br />
                                        {showMore ? ReactHtmlParser(dataDetail?.attribute?.description) : (null)}
                                        {dataDetail?.attribute?.description.length > 0 && (
                                            <div className="col-12 mgt-5 in-f">
                                                <button className="container-detail-button in-f" onClick={toggleShowMore}>
                                                    <a><i className={showMore ? "fa fa-angle-up pdr-5" : "fa fa-angle-down pdr-5"}></i>{showMore ? "THU NHỎ" : "XEM THÊM"}</a>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                ) : (null)
                            }
                        </div>
                        {
                            dataDetail?.sku ? (
                                <>
                                <ProductSame sku={dataDetail.sku} />
                                <BundleProduct sku={dataDetail.sku} />
                                </>
                            ):(null)
                        }
                        

                        {/* <div className="row pdx-24 mgt-10 pdt-20 bg-white">
                            <div className="col-12 gift-bixu in-f">
                                <span>Ba Mẹ hiện có <span className="color-detail-bixu"> {bixu} Bixu</span> để đổi quà</span>
                            </div>
                            <div className="col-12 mgy-20 in-f">
                                <div className="box-gift" onClick={handleLogout}>
                                    <div className="col-12 bow-tie">
                                        <img src="/../images/product/bow_tie.png" alt="icon"/>
                                    </div>
                                    <div className="col-12 text-gift-now">
                                        <span>ĐỔI QUÀ NGAY</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}


                        <div style={{ height: 135 }}></div>
                        <div className="row mgt-10 button-footer mgx-0 bg-detail">
                            <div className="col-12 text-detail-rate pdx-20">
                                <span className="text-rate">Nhận <span className="text-red">{dataDetail.amountAffiliate ? FromatNumberVIE(dataDetail.amountAffiliate) : 0}đ</span> cho mỗi sản phẩm bán ra</span><br />
                                <span className="rate">Tỉ lệ hoa hồng {dataDetail.amountAffiliatePercent ? FromatNumberVIE(dataDetail.amountAffiliatePercent) : 0}</span>
                            </div>
                            <div className="col-12 button-detail in-f pdx-10 mgt-10">
                                <div className="col-2 bottom-like">
                                    <img onClick={() => handleWishlist(dataDetail.sku, dataDetail.isFavorite)} src={wishlist || dataDetail.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><br />
                                    <span className="text-like">Yêu thích</span>
                                </div>
                                {
                                     dataDetail?.online === true && +dataDetail?.quantity >0 ? (
                                        <>
                                            <div className="col-5 pdr-5"><button className="button-add" onClick={handleBy}>THÊM VÀO GIỎ</button></div>
                                            <div className="col-5 pdl-5"><button className="button-buy" onClick={handleByNow}>MUA NGAY</button></div>
                                        </>
                                     ):(
                                        <>
                                        <div className="col-5 pdr-5"><button className="button-add" disabled>THÊM VÀO GIỎ</button></div>
                                        <div className="col-5 pdl-5"><button className="button-buy" disabled>MUA NGAY</button></div>
                                        </>
                                     )
                                }
                               
                            </div>
                        </div>

                    </div>
                    <div className="group-icon-bottom-right">
                        <div className={`mgt-10 ${isVisible ? 'visible' : 'd-none'}`} onClick={scrollToTop}>
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/icontotop.png" alt="icon"></img>
                        </div>
                        <div onClick={() => handleRedirrect('/san-xu.html')} className={`mgt-10 ${isContactCheck === true ? 'd-block' : 'd-none'}`}>
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/iconsanxu.png" alt="icon"></img>
                        </div>
                        <div onClick={() => setModalCallIsOpen(true)} className={`mgt-10 ${isContactCheck === true ? 'd-block' : 'd-none'}`}>
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/iconcall.png" alt="icon"></img>
                        </div>
                        <div onClick={() => setModalChatIsOpen(true)} className={`mgt-10 ${isContactCheck === true ? 'd-block' : 'd-none'}`}>
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/iconchat.png" alt="icon"></img>
                        </div>
                        <div onClick={() => setIsContactCheck(!isContactCheck)} className="mgt-10">
                            {
                                isContactCheck === true ? (
                                    <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/iconx.png" alt="icon"></img>

                                ) : (
                                    <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/icon3cham.png" alt="icon"></img>

                                )
                            }
                        </div>
                    </div>
                    <div id="modal-call">
                        {modalCallIsOpen && (
                            <div className="modal">
                                <div className="modal-content">
                                    <div className="modal-body p-0">
                                        <div className="text-center">
                                            <button onClick={() => handleCall()} className="btn-confirm pdy-10">
                                                <i className="fas fa-headset text-red mgr-10"></i> Gọi 1800 6886 (Miễn phí)
                                            </button>
                                        </div>
                                        <div className="text-center mgt-10">
                                            <button onClick={() => setModalCallIsOpen(false)} className="btn-cancel pdy-10 mgt-10">
                                                Hủy
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div id="modal-chat">
                        {modalChatIsOpen && (
                            <div className="modal">
                                <div className="modal-content">
                                    <div className="modal-body p-0">
                                        <div className="text-center">
                                            <button onClick={() => handleChatMess()} className="btn-confirm pdy-10">
                                                Messenger
                                            </button>
                                        </div>
                                        <div className="text-center mgt-10">
                                            <button onClick={() => handleChatZalo()} className="btn-confirm pdy-10 mgt-10">
                                                Zalo
                                            </button>
                                        </div>
                                        <div className="text-center mgt-10">
                                            <button onClick={() => setModalChatIsOpen(false)} className="btn-cancel pdy-10 mgt-10">
                                                Hủy
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div id="modal-msg-mobile">
                        {configMsg && (
                        <div className="modal">
                            <div className="modal-content">
                                <div className="modal-body p-0">
                                    <div>
                                    Sữa mẹ là thức ăn tốt nhất cho sức khỏe và sự phát triển toàn diện của trẻ sơ sinh và trẻ nhỏ! Vui lòng xác nhận bạn là nhân viên y tế hoặc có nhu cầu tìm hiểu thông tin về sản phẩm theo chỉ dẫn của nhân viên y tế.
                                    </div>
                                    <div className="text-center mgt-10">
                                        <button onClick={() => setConfigMsg(false)} className="btn-cancel pdy-10 mgt-10">
                                            Xác nhận
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}
                    </div>

                    </LayoutEmpte>
                ):(null)
            }
            {
                Brand.includes(slug) === true ?(
                    <Layout>
                        <HeaderMobile Type={'HeaderDetailProduct'} showBanner={false} linkBanner="" showText={true} showSearchIcon={true} showNoti={true} showCart={true} showTitle={title} />
                        {/* <div className="breadcurmb-mobile">
                            <ul className="m-0 p-3">
                            <li>
                                <a href="/"><img className="icon-home" src="/static/image/icon-home-br.png" alt="hone" /></a><i className="fa-solid fa-chevron-right"></i>
                            </li>
                            <li>
                                <a href={"/"+slug+"html"}>{productMeta.name}</a>
                            </li>
                        </ul>
                        </div> */}
                        <BrandPage uri={slug} des={productMeta.description}/>
                    </Layout>
                ):(null) 
            }

            {
                categoryCate.includes(slug) === true ? (
                    <Layout>
                        <HeaderMobile Type={'HeaderDetailProduct'} showBanner={false} linkBanner="" showText={true} showSearchIcon={true} showNoti={true} showCart={true} showTitle={title} />
                        {/* <div className="breadcurmb-mobile"><ul className="m-0 p-3">
                            <li>
                                <a href="/"><img className="icon-home" src="/static/image/icon-home-br.png" alt="hone" /></a><i className="fa-solid fa-chevron-right"></i>
                            </li>
                            <li>
                                <a href={"/"+slug+"html"}>{productMeta.name}</a>
                            </li>
                        </ul>
                        </div> */}
                        <ProductListPage uri={slug} des={productMeta.description} key='product-list'/>
                     </Layout>
                ):(null) 
            }
        </>
    )
// }else{
//     return <div className="loading-page-app-item pdy-5" style={{textAlign:"center"}}> <img src="/../images/loading.gif" alt="icon"/></div>;
// }
}
export default Product;